import './index.scss';
import * as actionCreators from '../action-creators';
import ReimbursementSummary from './reimbursement-summary';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.reimbursementSummary.summary.busyCounter
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummary);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/index.js